import { render, staticRenderFns } from "./LoggedInProfile.vue?vue&type=template&id=6b8dfa09&scoped=true"
import script from "./LoggedInProfile.vue?vue&type=script&lang=js"
export * from "./LoggedInProfile.vue?vue&type=script&lang=js"
import style0 from "./LoggedInProfile.vue?vue&type=style&index=0&id=6b8dfa09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8dfa09",
  null
  
)

export default component.exports